import { RadioGroupButtonItem } from './RadioGroupButtonItem';
import type {
  RadioGroupButtonConfig,
  RadioGroupButtonItemProps,
} from './RadioGroupButtonItem';

export interface RadioGroupButtonProps<T>
  extends Pick<RadioGroupButtonItemProps<T>, 'theme'> {
  onClick?: (selected: T) => void;
  buttonsConfig?: RadioGroupButtonConfig<T>[];
  selected?: T;
  small?: boolean;
}

export const RadioGroupButton = <T,>({
  onClick,
  buttonsConfig,
  selected,
  small,
  theme = 'light',
  ...props
}: RadioGroupButtonProps<T>) => {
  return (
    <div
      className="flex items-center justify-center"
      role="radiogroup"
      {...props}
    >
      {buttonsConfig?.map((buttonConfig) => (
        <RadioGroupButtonItem
          key={String(buttonConfig.id)}
          theme={theme}
          onClick={() => onClick?.(buttonConfig.id)}
          selected={selected === buttonConfig.id}
          buttonConfig={buttonConfig}
          small={small}
        />
      ))}
    </div>
  );
};
